import { useContext, useEffect, useState } from "react";
import { Storage } from '@ionic/storage';
import { formatLogLevel, LogLevel, useLogger } from "../../services/LogService";
import { ActionType } from "../../state/GlobalState";
import { AppContext } from "../../state/AppContextProvider";

export const LoggingStorage = ( { children }) => {

    const logger = useLogger("LoggingStorage");

    const { state, dispatch } = useContext(AppContext);

    const [storage, setStorage] = useState<Storage | null>(null);
    const [isStorageReady, setStorageReady] = useState(false);

    /* Dispatch logLevel to update the global state */
    const loadLogLevel = (logLevel: LogLevel) => {
        dispatch({ type: ActionType.SetLogLevel, payload: logLevel });
        logger.info("logLevel loaded:", formatLogLevel(logLevel));
    }

    /* Init. state from storage */
    useEffect(() => {
        if (isStorageReady === false) {
            logger.info("Init. logging state");
            new Storage().create().then(async (s) => {
                setStorage(s);
                const v: string | null = await s.get("logLevel");
                let logLevel = state.logLevel;
                if (v !== null && LogLevel[v] !== null) {
                    logLevel = LogLevel[v];
                }
                loadLogLevel(logLevel);
                setStorageReady(true);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* Update storage when logLevel change */
    useEffect(() => {
        logger.debug("useEffect() level=" + state.logLevel, storage);
        if (storage) {
            storage.set("logLevel", LogLevel[state.logLevel]).then(() => {
                logger.info("logLevel saved!", LogLevel[state.logLevel]);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.logLevel]);

    return (state.isLoggerReady ? children : <></>);
};